var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"data-grid-group-cell-text"},[(_vm.cellIcon)?_c('el-tooltip',{attrs:{"content":_vm.renderActionText,"placement":"top","effect":"light","enterable":false}},[_c('i',{class:_vm.cellIcon})]):_c('span',[(_vm.renderActionIcon)?_c('i',{class:_vm.renderActionIcon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.renderActionText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }